const FormResources = {

    form_data:{
        room_usage:     '',
        vacant_bed:     ''
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Room Usage:',
            model_name: 'room_usage',
            ref:        'room_usage_input',
            ref_alt:    'room_usage_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Vacant Bed Adjustment:',
            model_name: 'vacant_bed',
            ref:        'vacant_bed_input',
            ref_alt:    'vacant_bed_input_alt',
            required:   true,
        },
    ]

}

export default FormResources;